import ___default from "lodash";
const getTriggerCondition = (triggerEvents) => {
  return triggerEvents.map((te) => {
    const eventName = te.name;
    const eventString = te.events.filter((e) => !!e.key).map((e) => `ExtendedProperties["${e.key}"] == "${e.value}"`).join(" AND ");
    return `(EventName == "${eventName}"${!!eventString ? " AND " + eventString : ""})`;
  }).join(" OR ");
};
const _parseTriggerCondition = (sideStreamTriggerExpression) => {
  const triggerEventExpressions = sideStreamTriggerExpression.split(" OR ");
  return triggerEventExpressions.map((te) => {
    const properties = te.split(" AND ");
    const [eventNameString, ...extendedPropertiesStrings] = properties;
    const name = eventNameString.replace(new RegExp('"', "g"), "").replace("(EventName == ", "").replace(")", "");
    const events = extendedPropertiesStrings.map((e) => {
      const [key, value] = e.replace(new RegExp('"', "g"), "").replace("ExtendedProperties[", "").replace("]", "").replace(")", "").split(" == ");
      if (value === "true" || value === "false")
        return { key, value, type: "Boolean" };
      else if (Number(value))
        return { key, value, type: "Number" };
      else
        return { key, value, type: "String" };
    });
    return { name, events };
  });
};
const parseTriggerCondition = (sideStreamTriggerExpression) => {
  if (!!!sideStreamTriggerExpression || !sideStreamTriggerExpression.includes("EventName"))
    return { isAutomatic: false, triggerEvents: [] };
  const nonAutomaticSubStrs = ["EventName", "ExtendedProperties", "==", "(", ")", "[", "]", '"'];
  const triggerEvents = _parseTriggerCondition(sideStreamTriggerExpression);
  const isAutomatic = !___default.some(triggerEvents, (event) => {
    return !!!event.name || ___default.some(
      nonAutomaticSubStrs,
      (s) => event.name.includes(s) || ___default.some(event.events, (ev) => {
        return !!!ev.key || ___default.some(nonAutomaticSubStrs, (s2) => ev.key.includes(s2) || !!ev.value && ev.value.includes(s2));
      })
    );
  });
  return { isAutomatic, triggerEvents: isAutomatic ? triggerEvents : [] };
};
export {
  getTriggerCondition,
  parseTriggerCondition
};
//# sourceMappingURL=AutoGeneratedTriggering.utils.js.map
